import { useEffect, useRef } from 'react';
import { relewiseMappingService } from '../MappingService';
import { relewiseTrackingService } from '../TrackingService';

export const useCategoryViewTracker = (listId: string | undefined) => {
    const lastTrackedListRef = useRef<string | undefined>();

    useEffect(() => {
        if (!listId || lastTrackedListRef.current === listId) {
            return;
        }

        relewiseTrackingService.trackCategoryView(relewiseMappingService.prefixId(listId));
        lastTrackedListRef.current = listId;
    }, [listId]);
};
